<template>
	<v-select 
		:id="id" 
		:name="getName" 
		:class="['c-input-select2', multiple ? 'c-input-select2-multiple' : '', cssClass, isValid == false ? 'is-invalid' : '']" 
		:style="getCssStyle"
		v-model="vSelectValue" 
		:disabled="disabled"
		@change="onChange('change')"
		@input="onChange('input')"
		:options="getOptions"
		:multiple="multiple ? true : false">
	</v-select>

	<span class="validation-text" v-if="isValid == false && validationMessage != ''">
		<small style="color: red" v-html="validationMessage"></small>
	</span>
</template>





<script>
import allFormElementPropsMixin from "./all-form-element-props-mixin";

export default {

	emits: ["change", "update:modelValue"],
	
	mixins: [allFormElementPropsMixin],

	props: {

		//TODO: Obsolete/deprecated. Don't remove until removing from implementations.
		initialValue: {
			type: [ Number, String, Array, Object, null ]
		},
		


		/**
		 * A standard setup of options with "value" and "text" properties.
		 * Use this for a standard list WIHTOUT option groups.
		 */
		options: {
			type: [ Array, null ],
			default: null
		},


		searchablePlaceholderText: {
			type: String,
			required: false,
			default: "Start typing, press down, or click to show options to select"
		},



		/**
		 * A standard setup of options with "value" and "text" properties.
		 * Use this for a list WITH option groups.
		 * 
		 * Item structure:
		 * {
		 *   value: "",
		 *   text: "",
		 *   children: [
		 *     {
		 *        value: "",
		 *        text: "",
		 *     }
		 *   ]
		 * }
		 * If `children` does NOT exist on an object, it's just a top level <option>.
		 * If `children` DOES exist then it is an <optgroup> and the children are the <options>s
		 */
		groupedOptions: {
			type: Array,
			default: () => []
		},



		//TODO: Not implemented
		// placeholder: {
		// 	type: String,
		// 	required: false,
		// 	default: "Select"
		// },


	
		/**
		 * ** DEPRECATED **  
		 * A custom data set, where "value" and "text" for standard "options"
		 * are mapped from the "dataValue" and "dataText" (name of the properties in the data items) respectively.
		 */
		data: {
			type: Array,
			default: null
		},

		/**
		 * ** DEPRECATED **  
		 */
		dataValue: {
			type: String,
			default: ""
		},

		/**
		 * ** DEPRECATED **  
		 */
		dataText: {
			type: String,
			default: ""
		},



		/**
		 * Set to `true` if multi-select is enabled.
		 */
		multiple: {
			type: Boolean,
			default: false
		},



        modelValue: {
            type: [ Number, String, Array, Object, null ],
            default: '',
            required: true
        },


	},





	data()
	{
		return {
			value: [],

			vSelectValue: [],
		};
	},





	mounted()
	{
		this.init();
	},





	created()
	{
	},





	watch: {
		//NOTE: This does nothing. See `value` watch.
		modelValue: function(to, from)
		{
			console.log("watch[modelValue][" + this.id + "]: value=", this.value, "to=", to, "from=", from);

			// const isArray = Array.isArray(this.value);

			// //if (!isArray && this.value.toLowerCase() == to.toLowerCase()) return;
		
			if (to == null || to == undefined)
			{
				console.log("   watch[modelValue][" + this.id + "]: NO VALUE passed in");
				return;
			}
			var item = this.getItemFromVSelectOptions(to);
			console.log("   watch[modelValue][" + this.id + "]: to=", to, " | item=", item);
			this.setVSelectModel(item);

			// //this.value = to;
			// //this.syncModelValue(to);
		},




		value: function(to, from)
		{
			console.log("watch[value][" + this.id + "]: value=", this.value, "to=", to, "from=", from);

			if (to == null || to == undefined)
			{
				console.log("   watch[modelValue][" + this.id + "]: NO VALUE passed in");
				return;
			}

			// // v-select doesn't have a change() event, so we're going to emulate it with this.
			// this.onChange();
		},




		
		vSelectValue: function(to, from)
		{
			console.log("watch[vSelectValue][" + this.id + "]: value=", this.value, "to=", to, "from=", from);
			const isArray = Array.isArray(to);

			let codes = [];
			if (isArray)
			{
				if (this.isSelectValueChanged(to, from))
				{
					console.log("   watch[vSelectValue][ARRAY][" + this.id + "]: NO CHANGE between updates");
					return;
				}
				
				to.forEach(z => {
					if (z.code) codes.push(z.code);
				});
			}
			else
			{
				if (to == null || to == undefined)
				{
					console.log("   watch[vSelectValue][SINGLE][" + this.id + "]: NO VALUE passed in");
					return;
				}
				codes = to.code;
			}

			console.log("   watch[vSelectValue][" + this.id + "]: codes=", codes);

			this.onChange2(codes);
		},




		options: {
			handler: function(to, from)
			{
				console.log("watch[options][" + this.id + "]: to=", to, "from=", from);

				this.init();
			},
			deep: true
		}
	},





	computed: {
		/**
		 * Get the value of the "name" property of the rendered SELECT element.
		 */
		getName() 
		{
			return this.name ? this.name : this.id;
		},



		/**
		 * Return the data structure containing the valuyes to render into 
		 * OPTION elements, based on the type of source data passed into the props.
		 */
		getOptions()
		{
			return this.getVSelectOptions();
		}
	},





	methods: {
		init()
		{
			// this.setVSelectModel(this.modelValue);
			// this.syncModelValue(this.modelValue);

			var item = this.getItemFromVSelectOptions(this.modelValue);
			this.setVSelectModel(item);
		},




		setVSelectModel(value)
		{
			console.log("setVSelectModel(): value=", value);
			this.vSelectValue = value;
		},










		/**
		 * Return the data structure containing the values required for v-select
		 * OPTION elements, taken from the type of source data passed into the props
		 * that uses the standard Lotus list options.
		 */
		getVSelectOptions()
		{
			let options = [];

			if (this.data)
			{
				// Generate an options array from the supplied raw data and identified value and text fields.
				options = this.$root.getSelectOptionsFromData(this.data, this.dataValue, this.dataText);
				
			}
			else
			{
				// Use a correctly pre-formatted options list.
				options = this.options;
			}


			options = options.map(function (z) {
				return { code: z.value, label: z.text };
			});

			return options;
		},










		getItemFromVSelectOptions(codeValue)
		{
			if (codeValue == null || codeValue === undefined)
			{
				console.warn("getItemFromVSelectOptions(" + this.id + "): codeValue is NULL or UNDEFINED");
				return { code: '', label: '' };	
			}

			var options = this.getVSelectOptions();

			if (!options || options.legth == 0)
			{
				console.warn("getItemFromVSelectOptions(" + this.id + "): No options available.");
				return { code: '', label: '' };	
			}

			const isArray = Array.isArray(codeValue);

			if (isArray)
			{
				console.log("getItemFromVSelectOptions(" + this.id + ")(ARRAY): codeValue=", codeValue);

				let items = []

				codeValue.forEach(z => {
					const item = options.find(o => o.code.toLowerCase() == z.toLowerCase());
					if (item) items.push(item);
				});
				
				return items;
			}
			else
			{
				console.log("getItemFromVSelectOptions(" + this.id + ")(SINGLE): codeValue=", codeValue, " | options=", options);

				try
				{
					const item = options.find(z => z.code.toLowerCase() == codeValue.toLowerCase());
					console.log("getItemFromVSelectOptions(" + this.id + ")(SINGLE): item=", item);
					return item;
				}
				catch (ex)
				{
					console.error("getItemFromVSelectOptions(" + this.id + ")(SINGLE): Error for code value: ", codeValue, ". Ex=", ex);
					return '';
				}
			}
		},










		syncModelValue(toValue)
		{
			console.log("select2.syncModelValue(" + this.id + "): toValue=", toValue);
		
			this.value = toValue;
			if (!toValue) this.value = "";
		
			if (this.multiple && !toValue)
			{
				//console.log("   -- watch[modelValue][" + this.id + "]: MULTIPLE",);
				this.value = [];
			}
		},



		onChange(value)
		{
			//TODO: Obsolete. Copy/past from input-select I think
			// console.log("onChange():");
			// console.log("  onChange(): value=", value);

			// console.log("  onChange(): this.value=", this.value);

			// const isArray = Array.isArray(this.value);

			// console.log("  onChange(): isArray=", isArray);

			// let selected = this.value;
			// if (isArray)
			// {
			// 	// An array of objects. Return an array of the .code values.
			// 	selected = this.value.map(function (z) {
			// 		// Ternary is if the model value passed has array values with just the raw value of the expected code, not an actual { code: "", label: "" object}
			// 		return z.code ? z.code : z;
			// 	});
			// }
			// else
			// {
			// 	// A single object. Just get the "code";
			// 	// Ternary is if the model value passed in is just the raw value of the expected code, not an actual { code: "", label: "" object}
			// 	// 'Object.hasOwn' vs 'value.code' truthy check because the code may be a blank value.
			// 	selected = Object.hasOwn(this.value, 'code') ? this.value.code : this.value;
			// }

			// console.log("  onChange(): selected=", selected);
			
			
			// this.$emit('change', selected);
			// this.$emit('update:modelValue', selected);
		},



		isSelectValueChanged: function(to, from)
		{
			console.log("isSelectValueChanged(" + this.id + "): value=", this.value, "to=", to, "from=", from);


			const isArray = Array.isArray(to);

			let toCodes = [];
			let fromCodes = [];
			if (isArray)
			{
				to.forEach(z => {
					if (z.code) toCodes.push(z.code);
				});
				from.forEach(z => {
					if (z.code) fromCodes.push(z.code);
				});

				if(toCodes.sort().join(',')=== fromCodes.sort().join(',')){
					return true;	// Sames values in both
				}
				return false;	// Not the same
			}
			else
			{
				return to.code == from.code;
			}
		},




		onChange2(value)
		{
			console.log("onChange(2):");
			console.log("  onChange(2): value=", value);

			// console.log("  onChange(2): this.value=", this.value);

			// const isArray = Array.isArray(this.value);

			// console.log("  onChange(2): isArray=", isArray);

			// let selected = this.value;
			// if (isArray)
			// {
			// 	// An array of objects. Return an array of the .code values.
			// 	selected = this.value.map(function (z) {
			// 		// Ternary is if the model value passed has array values with just the raw value of the expected code, not an actual { code: "", label: "" object}
			// 		return z.code ? z.code : z;
			// 	});
			// }
			// else
			// {
			// 	// A single object. Just get the "code";
			// 	// Ternary is if the model value passed in is just the raw value of the expected code, not an actual { code: "", label: "" object}
			// 	// 'Object.hasOwn' vs 'value.code' truthy check because the code may be a blank value.
			// 	selected = Object.hasOwn(this.value, 'code') ? this.value.code : this.value;
			// }

			// console.log("  onChange(2): selected=", selected);
			
			
			this.$emit('change', value);
			this.$emit('update:modelValue', value);
		},
	}
}
</script>





<style scoped lang="scss">
	@use "/assets/sass/_global.scss" as *;


.c-input-select
{
	width: 100%;

	// text-indent: 5px;


	option
	{
		padding: 4px;
	}


	option:checked
	{
		color: rgb(64, 158, 255);
		font-weight: bold;
	}
}

.c-input-select-multiple
{
	// This should cover the first 5 items in the list
	height: 142px;
}



// Disabled styling same as Element UI on native time picker
.c-input-native-not-grouped:disabled
{
	background-color: #F5F7FA;
	border-color: #E4E7ED;
	color: #C0C4CC;
	cursor: not-allowed;
}
</style>